/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientIntake {
    class ClientIntakeContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityChecker: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected customDataContextConfig: Meevo.Model.ICustomDataContextConfig
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, customDataContextConfig, false);
        }

        initializeSections() {

        }

        initializeHeader() {

        }
    }
}